import { motion } from "framer-motion";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";

export function CalcSlider({ label, value, onChange, min, max, step, format, testId }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-medium text-foreground/80">{label}</label>
        <span className="font-serif text-xl text-primary">{format ? format(value) : value}</span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        data-testid={testId}
        className="w-full accent-secondary"
      />
      <div className="flex justify-between text-[11px] text-muted-foreground mt-1">
        <span>{format ? format(min) : min}</span>
        <span>{format ? format(max) : max}</span>
      </div>
    </div>
  );
}

const COLORS = ["hsl(24 45% 55%)", "hsl(155 30% 25%)"];

export function CalcDonut({ invested, returns, totalLabel = "Future Value" }) {
  const total = invested + returns;
  const data = [
    { name: "Invested", value: Math.max(invested, 0) },
    { name: "Returns", value: Math.max(returns, 0) },
  ];

  return (
    <div className="relative h-64">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            innerRadius={70}
            outerRadius={100}
            paddingAngle={2}
            dataKey="value"
            stroke="none"
          >
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i]} />
            ))}
          </Pie>
          <Legend
            verticalAlign="bottom"
            iconType="circle"
            formatter={(v, e) => <span className="text-xs text-foreground/70">{v}</span>}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 grid place-items-center pointer-events-none -mt-6">
        <div className="text-center">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{totalLabel}</div>
          <motion.div
            key={total}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-serif text-2xl text-primary mt-1"
          >
            ₹{total.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export function StatPill({ label, value, tone = "default" }) {
  const tones = {
    default: "bg-muted/60 text-foreground",
    primary: "bg-primary/5 text-primary",
    secondary: "bg-secondary/10 text-secondary",
  };
  return (
    <div className={`rounded-xl p-4 text-center ${tones[tone]}`}>
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
      <div className="font-serif text-lg mt-1">{value}</div>
    </div>
  );
}

export const fmtINR = (n) =>
  `₹${Math.round(n).toLocaleString("en-IN")}`;
